<script setup lang="ts">
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/authStore';

const router = useRouter();
const authStore = useAuthStore();

onMounted(async () => {
  const savedName = localStorage.getItem('username');

  if (savedName) {
    // 1. 更新 Pinia 狀態
    authStore.setLoginStatus(true);

    // 2. 如果在登入頁或首頁，導向功能頁
    // 使用 isReady 確保路由已加載
    await router.isReady();
    if (router.currentRoute.value.path === '/login' || router.currentRoute.value.path === '/') {
      router.push('/user');
    }
  }
});
</script>

<template>
  <div id="app-root">
    <router-view />
  </div>
</template>

<style>
:root {
  --content-max-width: 1100px;
  --mobile-padding: 1rem;
  --desktop-padding: 2rem;
}

#app-root {
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
}
</style>